import styled from '@emotion/styled'
import {Box} from '@mui/material'

const DropdownLoadingBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: theme.spacing(4)
}))

export {DropdownLoadingBox}
